import { useParams } from "react-router-dom";

import UserSettingRegistration from './UserSettingRegistration';
import UserSettingBasis from './UserSettingBasis';
import UserSettingOther from './UserSettingOther';
import UserSettingPackage from './UserSettingPackage';

export default function UserSettingsPages() {
  const params = useParams();
  // const match = useRouteMatch();
  let page = '';

  switch (params.id) {
    case "registration": page = <UserSettingRegistration />; break;
    case "basis": page = <UserSettingBasis />; break;
    case "other": page = <UserSettingOther />; break;
    case "package": page = <UserSettingPackage />; break;

    default: break;
  }

  return page;
}